import { AnswerMapper } from 'mapper/AnswerMapper';

export const answerMapper = new AnswerMapper();
